<template>
	<v-container fill-height fluid>
		<v-row align="center" justify="space-around" class="text-center">
			<v-col>
				<h2>How to connect your monday.com account</h2>
				<br />
				<p class="body-1">
					1. Make sure the Ply app is installed on your monday.com account <br /><small style="color: #a8a8a8"
						>Note: The app might already be installed. If it is, you can skip this step</small
					>
				</p>
				<a target="_blank" href="https://auth.monday.com/oauth2/authorize?client_id=092eee7e7f94211af50147765ed06240&response_type=install">
					<img
						alt="Add to monday.com"
						height="42"
						src="https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/uploads/Tal/4b5d9548-0598-436e-a5b6-9bc5f29ee1d9_Group12441.png"
					/> </a
				><br />
				<p class="body-1">
					2. Once installed, <a :href="redirect" draggable="false" class="my-3">click here to connect your monday.com account to Ply</a>
				</p>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'PreProfileConnectMonday',
	props: { redirect: { type: String } },
};
</script>

<style scoped lang="scss">
a {
	display: inline-block;
	position: relative;

	&:hover {
		opacity: 0.9;
	}
	&:active {
		top: 1px;
	}

	img {
		width: 100%;
	}
}
</style>
